// GENERATED by scripts/normalize-legal.mjs - DO NOT EDIT BY HAND.
// Slug + display title only, safe to import into eagerly-loaded chrome.
import type { LegalDocMeta } from './types';

export const LEGAL_DOCS_MANIFEST: readonly LegalDocMeta[] = [
  { id: "terms", slug: "terms", displayTitle: "Terms of Use and Content License Terms" },
  { id: "privacy-policy", slug: "privacy-policy", displayTitle: "Privacy Policy" },
  { id: "refund-policy", slug: "refund-policy", displayTitle: "Refund and Cancellation Policy" },
  { id: "cookie-notice", slug: "cookie-notice", displayTitle: "Cookie Notice" },
  { id: "accessibility-statement", slug: "accessibility-statement", displayTitle: "Accessibility Statement" },
];
